<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="top-title">添加合作社</div>
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        :inline="true"
        label-width="150px"
        class="form-add"
      >
        <!-- 合作社信息 -->
        <div class="plate">
          <div class="title">
            选择合作社<label>（可从合作社库中匹配已有信息）</label>
          </div>
          <el-form-item label="合作社名称">
            <span style="font-size: 16px; color: #666666">{{
              cooperativeCur.company
            }}</span
            >&nbsp;
            <el-button
              type="primary"
              plain
              icon="el-icon-plus"
              class="btn-add"
              @click="handleDialogShow()"
              >点击选择
            </el-button>
          </el-form-item>
        </div>
        <div class="plate">
          <div class="title">登录信息</div>
          <el-form-item prop="mobile" label="登录手机号" ref="mobile">
            <el-input
              placeholder="请输入登录手机号"
              v-model.trim="form.mobile"
            ></el-input>
          </el-form-item>
          <el-form-item prop="userName" label="联系人姓名" ref="userName">
            <el-input
              placeholder="请输入联系人姓名"
              v-model.trim="form.userName"
              maxlength="30"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="businessZoneId"
            label="业务区域"
            ref="businessZoneId"
          >
            <el-cascader
              ref="regionCascader"
              :options="businessZoneList"
              :props="zoneProps"
              v-model="checkedZone"
              placeholder="请选择业务区域"
              @change="businessZoneChange"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item
            prop="businessPersonId"
            label="业务负责人"
            ref="businessPersonId"
          >
            <el-select
              placeholder="请选择业务负责人"
              v-model="form.businessPersonId"
            >
              <el-option
                v-for="(item, index) in dutyPersonList"
                :key="index"
                :label="item.personName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="plate">
          <div class="title">合作社信息</div>
          <el-form-item class="w100" label="营业执照">
            <el-upload
              class="upload-large"
              id="businessLicense"
              :action="'#'"
              accept="image/jpeg,image/gif,image/png"
              :multiple="false"
              :show-file-list="false"
              list-type="picture-card"
              :on-preview="handlePreviewImg"
              :data="{ xtype: 'ysb_product', type: 'image' }"
              :on-success="(file) => handleImgSuccess(file, 'businessLicense')"
              :http-request="handleCustomUpload"
            >
              <!-- <div class="uploadbox" > -->
              <img
                v-if="form.businessLicenseUrl == ''"
                class="place-img"
                src="@/assets/upload-bussiness.png"
              />
              <img v-else :src="form.businessLicenseUrl" />
              <!-- </div> -->
            </el-upload>
          </el-form-item>
          <el-form-item
            prop="cooperativeName"
            label="名称"
            ref="cooperativeName"
          >
            <el-input
              placeholder="请输入名称"
              v-model.trim="form.cooperativeName"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="socialCreditCode"
            label="统一社会信用代码"
            ref="socialCreditCode"
          >
            <el-input
              placeholder="请输入统一社会信用代码"
              v-model.trim="form.socialCreditCode"
            ></el-input>
          </el-form-item>
          <el-form-item label="所在地区" prop="region">
            <el-cascader
              ref="regionCascader"
              :options="regionData"
              :props="regionProps"
              v-model="checkedRegionData"
              placeholder="请选择所在地区"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="住所">
            <el-input
              placeholder="请输入住所"
              v-model.trim="form.address"
            ></el-input>
          </el-form-item>
          <el-form-item label="法定代表人" prop="corName" ref="corName">
            <el-input
              placeholder="请输入法定代表人"
              v-model.trim="form.corName"
            ></el-input>
          </el-form-item>
          <el-form-item label="成员出资总额">
            <el-input
              placeholder="请输入成员出资总额"
              v-model.trim="form.registeredCapitalCh"
            ></el-input>
          </el-form-item>
          <el-form-item label="成立时间">
            <el-date-picker
              v-model="form.foundingTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择成立时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="地图位置" prop="centre" class="map-form-item">
            <el-button
              type="primary"
              plain
              icon="el-icon-plus"
              class="btn-add"
              @click="openQueryMap"
            >
              点击编辑所在位置
            </el-button>
            <span class="map-address" v-if="centreAddress">
              地图位置
              <i></i> <span>{{ centreAddress }}</span>
            </span>
          </el-form-item>
        </div>
        <div class="plate">
          <div class="title">理事长信息</div>
          <el-form-item label="身份证人像面">
            <el-upload
              class="upload-large"
              id="idCardPortrait"
              :action="'#'"
              accept="image/jpeg,image/gif,image/png"
              :multiple="false"
              :show-file-list="false"
              list-type="picture-card"
              :on-preview="handlePreviewImg"
              :data="{ xtype: 'ysb_product', type: 'image' }"
              :on-success="(file) => handleImgSuccess(file, 'cardPortraitUrl')"
              :http-request="handleCustomUpload"
            >
              <!-- <div class="uploadbox-big"> -->
              <img
                v-if="form.directorDto.cardPortraitUrl == ''"
                class="place-img"
                src="@/assets/upload-idcard-portrait.png"
              />
              <img v-else :src="form.directorDto.cardPortraitUrl" alt="" />
              <!-- </div> -->
            </el-upload>
          </el-form-item>
          <el-form-item label="身份证国徽面">
            <el-upload
              class="upload-large"
              :action="'#'"
              accept="image/jpeg,image/gif,image/png"
              :multiple="false"
              :show-file-list="false"
              list-type="picture-card"
              :on-preview="handlePreviewImg"
              :data="{ xtype: 'ysb_product', type: 'image' }"
              :on-success="(file) => handleImgSuccess(file, 'cardEmblemUrl')"
              :http-request="handleCustomUpload"
            >
              <!-- <div class="uploadbox-big"> -->
              <img
                v-if="form.directorDto.cardEmblemUrl == ''"
                class="place-img"
                src="@/assets/upload-idcard-emblem.png"
              />
              <img v-else :src="form.directorDto.cardEmblemUrl" alt="" />
              <!-- </div> -->
            </el-upload>
          </el-form-item>
          <el-form-item label="理事长姓名">
            <el-input
              placeholder="请输入理事长姓名"
              v-model.trim="form.directorDto.directorName"
              maxlength="30"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="身份证号码"
            prop="directorDto.idCard"
            ref="directorDtoIdCard"
          >
            <el-input
              placeholder="请输入身份证号码"
              v-model.trim="form.directorDto.idCard"
            ></el-input>
          </el-form-item>
          <el-form-item label="住址">
            <el-input
              placeholder="请输入住址"
              v-model.trim="form.directorDto.address"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="电话"
            prop="directorDto.mobile"
            ref="directorDtoMobile"
          >
            <el-input
              placeholder="请输入电话"
              v-model.trim="form.directorDto.mobile"
            ></el-input>
          </el-form-item>
          <el-form-item class="w100" label="头像照片">
            <el-upload
              class="upload-small"
              :action="'#'"
              accept="image/jpeg,image/gif,image/png"
              :multiple="false"
              :show-file-list="false"
              list-type="picture-card"
              :on-preview="handlePreviewImg"
              :data="{ xtype: 'ysb_product', type: 'image' }"
              :on-success="(file) => handleImgSuccess(file, 'headUrl')"
              :http-request="handleCustomUpload"
            >
              <!-- <div class="uploadbox-small" > -->
              <i v-if="form.directorDto.headUrl == ''" class="el-icon-plus"></i>
              <img v-else :src="form.directorDto.headUrl" alt="" />
              <!-- </div> -->
            </el-upload>
          </el-form-item>
        </div>
        <div class="plate">
          <div class="title">合作社荣誉信息<label>（可上传多张）</label></div>
          <el-form-item class="w100" label="荣誉证书">
            <el-upload
              class="upload-small"
              :action="'#'"
              accept="image/jpeg,image/gif,image/png"
              :multiple="true"
              :show-file-list="true"
              list-type="picture-card"
              :file-list="honorFileList"
              :on-preview="handlePreviewImg"
              :on-remove="(file) => handleRemoveImg(file, 'honor')"
              :data="{ xtype: 'ysb_product', type: 'image' }"
              :on-success="(file) => handleImgSuccess(file, 'honor')"
              :http-request="handleCustomUpload"
            >
              <!-- <div class="uploadbox-small" > -->
              <i class="el-icon-plus"></i>
              <!-- </div> -->
            </el-upload>
          </el-form-item>
        </div>
        <div class="plate">
          <div class="title">
            合作社经营场地信息<label>（可上传多张）</label>
          </div>
          <el-form-item class="w100" label="经营场地信息">
            <el-upload
              class="upload-small"
              :action="'#'"
              accept="image/jpeg,image/gif,image/png"
              :multiple="true"
              :show-file-list="true"
              list-type="picture-card"
              :file-list="premisesFileList"
              :on-preview="handlePreviewImg"
              :on-remove="(file) => handleRemoveImg(file, 'premises')"
              :data="{ xtype: 'ysb_product', type: 'image' }"
              :on-success="(file) => handleImgSuccess(file, 'premises')"
              :http-request="handleCustomUpload"
            >
              <!-- <div class="uploadbox-small" > -->
              <i class="el-icon-plus"></i>
              <!-- </div> -->
            </el-upload>
          </el-form-item>
        </div>
        <el-form-item style="padding-left: 160px">
          <el-button
            class="btn-submit"
            type="primary"
            :disabled="submitFlag"
            @click="handleSubmit('ruleForm')"
            >保存
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      class="dialog-selCooper"
      title="选择合作社"
      :visible.sync="dialogVisible"
      width="860px"
    >
      <el-form ref="filterForm" :model="filterForm" :inline="true">
        <el-form-item prop="company">
          <el-input
            v-model.trim="filterForm.company"
            placeholder="合作社名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="creditCode">
          <el-input
            v-model.trim="filterForm.creditCode"
            placeholder="统一社会信用代码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="legalPerson">
          <el-input
            v-model.trim="filterForm.legalPerson"
            placeholder="理事长"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter()">查询</el-button>
          <el-button
            type="primary"
            plain
            icon="el-icon-refresh-right"
            @click="handleReset('filterForm')"
            >清空</el-button
          >
        </el-form-item>
      </el-form>
      <el-table :data="tableData" style="width: 100%; margin-top: 10px">
        <template slot="empty">
          <div class="empty-table">
            <img class="icon-empty" src="@/assets/empty.png" />
            <p>
              没有查询到该合作社，<br />可退出当前选择进行信息录入或重新查询。
            </p>
            <el-button
              type="primary"
              @click="
                handleReset('filterForm');
                dialogVisible = false;
              "
              >退出选择</el-button
            >
          </div>
        </template>
        <el-table-column label="序号" width="80" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="company"
          label="合作社名称"
          min-width="43%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="credit_code"
          label="统一社会信用代码"
          min-width="30%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="legal_person"
          label="理事长"
          min-width="12%"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" min-width="10%" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="selCooperative(row)"
              >选择</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,prev, pager, next,jumper"
        :page-size="pagination.size"
        :page-count="pagination.pages"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-dialog>
    <el-dialog :visible.sync="previeImgVisible" title="图片预览">
      <div class="previewImg">
        <img class="img" width="100%" :src="previewImgUrl" alt="" />
      </div>
    </el-dialog>
    <!-- 选择地图位置组件 -->
    <QueryMap ref="queryMap" @onConfirmSelectAddress="onConfirmSelectAddress" />
  </el-main>
</template>

<script>
import regionSeatLibs from "utils/regionSeatLibs";
let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c));
import { uploadImg } from "@/api/uploadImg";
import QueryMap from "@/components/QueryMap/index";
export default {
  name: "CooperativeManageAdd",
  components: {
    QueryMap,
  },
  data() {
    const valiMobilePass = (rule, value, callback) => {
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!reg.test(value)) {
        callback(new Error("请输入正确的登录手机号"));
      } else {
        callback();
      }
    };
    const validateIdCard = (rule, value, callback) => {
      if (value && value.length != 18) {
        callback(new Error("请输入正确的身份证号"));
      } else {
        callback();
      }
    };
    const validateMobile = (rule, value, callback) => {
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (value && !reg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };

    return {
      form: {
        companyId: "", //选择了列表则有
        mobile: "",
        userName: "",
        businessZoneId: "",
        businessPersonId: "", //业务员id
        businessLicenseUrl: "", //营业执照url
        cooperativeName: "", //名称
        socialCreditCode: "", //统一社会信用代码
        provinceId: "", //住址省id
        provinceName: "", //住址省name
        cityId: "", //住址市id
        cityName: "", //住址市name
        areaId: "", //所在地区县id
        areaName: "", //所在地区县name
        townId: "", //住址镇乡id
        townName: "", //住址镇乡id
        villageId: "", //住址村id
        villageName: "", //住址村name
        address: "", //住所
        corName: "", //法定代表人
        registeredCapitalCh: "", //出资总额
        foundingTime: "", //成立时
        centre: "",
        region: "",
        //理事长信息
        directorDto: {
          directorName: "", //理事长姓名
          idCard: "", //身份证号码
          provinceId: "", //住址省id
          provinceName: "", //住址省name
          cityId: "", //住址市id
          cityName: "", //住址市name
          areaId: "", //所在地区县id
          areaName: "", //所在地区县id
          address: "", //住址
          cardPortraitUrl: "", //身份证人像url
          cardEmblemUrl: "", //身份证人像url
          headUrl: "", //头像照片url
          mobile: "", //手机号
        },
      },
      centreAddress: "",
      honorFileList: [], //荣誉图片
      premisesFileList: [], //经营场地图片
      // 选择合作社弹框内搜索数据
      filterForm: {
        company: "",
        legalPerson: "",
        creditCode: "",
        type: 40,
      },
      businessZoneList: [], //业务区域数据
      zoneProps: {
        value: "id",
        label: "zoneName",
        children: "children",
      },
      checkedZone: [], //选中的业务区域
      dutyPersonList: [], //业务负责人数据
      checkedRegionData: [],
      regionProps: {
        value: "i",
        label: "n",
        children: "c",
      },
      regionData,
      tableData: [],
      pagination: { page: 1, size: 10, total: 0 },
      rules: {
        mobile: [
          { required: true, message: "请输入登录手机号", trigger: "blur" },
          { validator: valiMobilePass, trigger: "blur" },
        ],
        userName: {
          required: true,
          message: "请输入联系人姓名",
          trigger: "blur",
        },
        businessZoneId: {
          required: true,
          message: "请选择业务区域",
          trigger: "change",
        },
        businessPersonId: {
          required: true,
          message: "请选择业务负责人",
          trigger: "change",
        },
        region: {
          required: true,
          message: "请选择所在地区",
          trigger: "change",
        },
        cooperativeName: {
          required: true,
          message: "请输入合作社名称",
          trigger: "blur",
        },
        socialCreditCode: {
          required: true,
          message: "请输入统一社会信用代码",
          trigger: "blur",
        },
        corName: {
          required: true,
          message: "请输入法定代表人",
          trigger: "blur",
        },

        ["directorDto.idCard"]: { validator: validateIdCard, trigger: "blur" },
        ["directorDto.mobile"]: { validator: validateMobile, trigger: "blur" },
      },
      dialogVisible: false,
      cooperativeCur: {}, //当前选中的合作社
      previewImgUrl: "", //预览图片url
      previeImgVisible: false, //预览图片弹框
      submitFlag: false,
    };
  },
  watch: {
    checkedRegionData(newVal) {
      this.form.provinceId = newVal[0] || "";
      this.form.cityId = newVal[1] || "";
      this.form.areaId = newVal[2] || "";
      let regionNames =
        newVal.length > 0 ? this.handleRegionName(newVal) : ["", "", ""];
      this.form.provinceName = regionNames[0];
      this.form.cityName = regionNames[1];
      this.form.areaName = regionNames[2];
      this.form.region = newVal.length > 0 ? "1" : "";
      this.$refs.ruleForm.validateField("region");
    },
    cooperativeCur(newVal) {
      this.form.companyId = newVal.id;
    },
  },
  created() {
    this.getBusinessZoneData();
  },
  methods: {
    businessZoneChange(newVal) {
      this.form.businessPersonId = "";
      this.form.businessZoneId =
        newVal.length > 0 ? newVal[newVal.length - 1] : "";
      newVal.length > 0 && this.getDutyPerson();
    },
    // 根据地区id查询name
    handleRegionName(ids) {
      let province = this.regionData.filter((item) => item.i == ids[0])[0];
      let city = province.c.filter((item) => item.i == ids[1])[0];
      let areaName = ids[2]
        ? city.c.find((item) => item.i == ids[2])
          ? city.c.find((item) => item.i == ids[2]).n
          : ""
        : "";
      return [province.n, city.n, areaName];
    },
    //搜索合作社列表
    handleFilter() {
      this.pagination.page = 1;
      this.getCompanyList();
    },
    //获取合作社列表数据
    getCompanyList() {
      let params = Object.assign({}, this.filterForm, {
        currentPage: this.pagination.page,
        pageSize: this.pagination.size,
      });
      this.$http.common.getCompanyList(params).then((res) => {
        this.tableData = res.data.users;
        if (this.pagination.page == 1) this.pagination.pages = res.data.pages;
      });
    },
    // 获取业务区域数据
    getBusinessZoneData() {
      this.$http.common.getBusinessZoneList({}).then((res) => {
        this.businessZoneList = res.data;
      });
    },
    // 获取业务负责人
    getDutyPerson() {
      this.$http.common
        .getDutyPerson({ businessZoneId: this.form.businessZoneId })
        .then((res) => {
          this.dutyPersonList = res.data;
        });
    },
    // 身份证识别
    disIdcard(imageUrl) {
      let LoadingInstance = this.$loading({
        target: document.getElementById("idCardPortrait"),
        text: "识别中...",
        background: "rgba(0,0,0,.5)",
      });
      this.$http.common
        .disIdcard({ imageUrl: imageUrl })
        .then((res) => {
          LoadingInstance.close();
          let cards = res.data.cards;
          this.form.directorDto.directorName = cards.name;
          this.form.directorDto.idCard = cards.id_num;
          this.form.directorDto.address = cards.address;
        })
        .catch(() => {
          LoadingInstance.close();
        });
    },
    isValidDate(dateString) {
      const pattern = /^\d{4}-\d{2}-\d{2}$/;
      return pattern.test(dateString);
    },
    //营业执照识别
    disBusinessLicense(imageUrl) {
      let LoadingInstance = this.$loading({
        target: document.getElementById("businessLicense"),
        text: "识别中...",
        background: "rgba(0,0,0,.5)",
      });
      this.$http.common
        .disBusinessLicense({ imageUrl: imageUrl })
        .then((res) => {
          LoadingInstance.close();
          let license = res.data.license;
          this.form.cooperativeName = license.name;
          this.form.socialCreditCode = license.reg_num;
          this.form.corName = license.legal_person;
          this.form.address = license.address;
          this.form.registeredCapitalCh = license.capital;
          this.form.foundingTime =
            license.start_date && license.start_date != -1
              ? license.start_date
              : "";
          this.form.foundingTime = this.isValidDate(this.form.foundingTime)
            ? this.form.foundingTime
            : "";
        })
        .catch(() => {
          LoadingInstance.close();
        });
    },
    //重置
    handleReset(formName) {
      this.$refs[formName].resetFields();
      this.handleFilter();
    },
    handleDialogShow() {
      this.dialogVisible = true;
      this.handleFilter();
    },
    //选择合作社
    selCooperative(row) {
      this.cooperativeCur = row;
      this.dialogVisible = false;
      this.form.companyId = row.id;
      this.form.mobile = row.contact_mobile;
      this.form.cooperativeName = row.company;
      this.form.socialCreditCode = row.credit_code;
      this.form.provinceId =
        row.region_id2 && row.region_id2 != "0" ? row.region_id2 : "";
      this.form.cityId =
        row.region_id3 && row.region_id3 != "0" ? row.region_id3 : "";
      this.form.areaId =
        row.region_id4 && row.region_id4 != "0" ? row.region_id4 : "";
      if (this.form.provinceId) {
        this.checkedRegionData = [this.form.provinceId, this.form.cityId];
        if (this.form.areaId) this.checkedRegionData.push(this.form.areaId);
      }
      this.form.address = row.address;
      this.form.corName = row.legal_person;
    },
    //页码切换
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.getCompanyList();
    },
    //提交
    handleSubmit(formName) {
      if (
        this.cooperativeCur.company &&
        this.cooperativeCur.company != this.form.cooperativeName
      ) {
        this.$message.warning("营业执照名称与合作社名称不一致，请修改后提交");
        return false;
      }
      this.$refs[formName].validate((valid, object) => {
        if (valid) {
          this.submitFlag = true;
          let honorFileList = this.honorFileList.map((item) => {
            return {
              fileName: item.name,
              picPath: item.url,
              fileType: 2,
            };
          });
          let premisesFileList = this.premisesFileList.map((item) => {
            return {
              fileName: item.name,
              picPath: item.url,
              fileType: 3,
            };
          });
          let params = {
            ...this.form,
            cooFileDtoList: [...honorFileList, ...premisesFileList],
          };
          this.$http.cooperative
            .addCooperative(params)
            .then(() => {
              this.$message.success("保存成功");
              this.$router.go(-1);
              this.submitFlag = false;
            })
            .catch(() => {
              this.submitFlag = false;
            });
        } else {
          for (let i in object) {
            let dom = this.$refs[i];
            if (Object.prototype.toString.call(dom) !== "[object Object]") {
              //这里是针对遍历的情况（多个输入框），取值为数组
              dom = dom[0];
            }
            dom.$el.scrollIntoView({
              //滚动到指定节点
              block: "end", //值有start,center,end，nearest，当前显示在视图区域中间
              behavior: "smooth", //值有auto、instant,smooth，缓动动画（当前是慢速的）
            });
          }
          this.submitFlag = false;
          return false;
        }
      });
    },
    //预览图片
    handlePreviewImg(file) {
      this.previewImgUrl = file.response ? file.response.url : file.url;
      this.previeImgVisible = true;
    },
    // 删除图片
    handleRemoveImg(file, type) {
      switch (type) {
        case "honor":
          this.honorFileList = this.honorFileList.map(
            (item) => item.url != file.url
          );
          break;
        case "premises":
          this.premisesFileList = this.premisesFileList.map(
            (item) => item.url != file.url
          );
          break;
      }
    },
    //自定义上传
    handleCustomUpload(content) {
      uploadImg(content)
        .then((res) => {
          content.onSuccess(res.data);
        })
        .catch((err) => {
          content.onError(err);
        });
    },
    //图片上传成功
    handleImgSuccess(file, type) {
      switch (type) {
        case "businessLicense":
          this.form.businessLicenseUrl = file.url;
          this.disBusinessLicense(file.url);
          break;
        case "cardPortraitUrl":
          this.form.directorDto.cardPortraitUrl = file.url;
          this.disIdcard(file.url);
          break;
        case "cardEmblemUrl":
          this.form.directorDto.cardEmblemUrl = file.url;
          break;
        case "headUrl":
          this.form.directorDto.headUrl = file.url;
          break;
        case "honor":
          this.honorFileList.push({ url: file.url, name: file.title });
          break;
        case "premises":
          this.premisesFileList.push({ url: file.url, name: file.title });
          break;
      }
    },
    /**
     * @description: 打开定位地图
     * @Author: quwandong
     * @Date: 2022-12-29 11:33:13
     */
    openQueryMap() {
      const checkedNodes = this.$refs.regionCascader.getCheckedNodes();
      let checkedRegionStr = "";
      if (checkedNodes[0]) {
        checkedRegionStr = checkedNodes[0].pathLabels.join("");
      }
      this.$refs.queryMap.openDialog(checkedRegionStr);
    },
    /**
     * @description:
     * @param {*} address
     * @Author: quwandong
     * @Date: 2022-12-29 11:35:51
     */
    onConfirmSelectAddress(addressDetail) {
      this.centreAddress = addressDetail.name
        ? addressDetail.address + addressDetail.name
        : addressDetail.address;

      this.form.centre = `${addressDetail.lonlat.lng},${addressDetail.lonlat.lat}`;
      this.$refs.ruleForm.validateField("centre");
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  padding: 0 !important;

  .top-title {
    height: 56px;
    line-height: 56px;
    border-bottom: 1px solid #e9ebee;
    padding: 0 20px;
    font-size: 20px;
    font-weight: bold;
    color: #018388;
  }

  .plate {
    padding: 10px 20px;

    .title {
      font-size: 18px;
      color: #333333;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      label {
        font-size: 16px;
        color: #999999;
      }

      &:before {
        content: "";
        display: inline-block;
        width: 5px;
        height: 18px;
        background: #018388;
        border-radius: 3px;
        margin-right: 5px;
      }
    }
  }

  .btn-add {
    padding: 9px 7px;
    font-size: 16px;
    border-radius: 3px;
  }
}

.form-add {
  .el-form-item {
    width: 600px;

    &.map-form-item {
      width: auto;
    }

    .el-input,
    .el-select,
    .el-cascader {
      width: 360px;
    }

    &.w100 {
      width: 100%;
    }
  }

  .btn-submit {
    width: 120px;
    height: 48px;
    background: #018388;
    border-radius: 4px;
    font-size: 18px;
  }
}

::v-deep {
  .map-address {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #222222;
    margin-left: 50px;

    i {
      display: inline-block;
      margin-left: 10px;
      width: 14px;
      height: 18px;
      background: url("~@/assets/weizhi_fanhui.png");
      background-size: 100% 100%;
    }

    > span {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #048489;
    }
  }
}

::v-deep .dialog-selCooper {
  .el-dialog {
    max-height: 80vh;
    overflow-y: auto;

    .el-form {
      .el-input {
        width: 200px;
      }

      .el-button {
        width: 74px;
        padding-left: 0;
        padding-right: 0;
        text-align: center;
      }
    }

    .el-table {
      margin-top: 0 !important;
    }
  }
}
</style>
